<template>
    <div>
        <div class="nav">
            <div class="nav_contain">
                <div class="logo" @click="to_index()">
                    <img :src="siteInfo.logo" alt="" v-if="mobile_w >767" />
                    <img src="../../static/images/logo_white.png" alt="" v-else />
                </div>
                <div class="nav_nr">
                    <div class="nav_li" :class="{active:$route.path.slice(0,5) === item.path.slice(0,5)}"
                         v-for="(item,index) in nav_list" :key="index" @click="nav_link(item.path)">
                        <span>{{item.name}}</span>
                        <div class="sub_nav" v-if="item.value === 1">
                            <i v-for="(subitem,i) in item.sub_nav" :key="i" @click="subnav_link(subitem.path)">{{subitem.name}}</i>
                        </div>
                        <div class="sub_nav" v-else-if="item.value === 2">
                            <i v-for="(subitem,i) in item.sub_nav" :key="i" @click.stop="to_service(subitem.id)">{{subitem.title}}</i>
                        </div>
                        <div class="sub_nav" v-else-if="item.value === 4">
                            <i v-for="(subitem,i) in item.sub_nav" :key="i" @click.stop="to_news(subitem.id)">{{subitem.name}}</i>
                        </div>
                    </div>
                    <div class="tab_index" :class="{active:Englist}" @click="to_tab()">
                        <b>中</b><i>/</i>English
                    </div>
                </div>
                <i class="el-icon-s-fold" @click="drawer = true"></i>
            </div>
        </div>
        <div class="nav_height" :class="{hide:$route.path === '/'}"></div>
        <el-drawer class="drawer"
                   :visible.sync="drawer"
                   :show-close="true"
                   size="40%"
                   :with-header="false">
            <div class="drawer_nav">
                <div class="logo" @click="to_index()">
                    <img src="../../static/images/logo.png" alt="" />
                </div>
                <div class="drawer_nav_li" :class="{active:$route.path.slice(0,5) === item.path.slice(0,5)}"
                     v-for="(item,index) in nav_list" :key="index">
                    <span @click="nav_link(item.path)">{{item.name}}</span>
                    <div class="drawer_sub_nav" v-if="item.value === 1">
                        <i v-for="(subitem,i) in item.sub_nav" :key="i"
                           @click="subnav_link(subitem.path)">{{subitem.name}}</i>
                    </div>
                    <div class="drawer_sub_nav" v-else-if="item.value === 2">
                        <i v-for="(subitem,i) in item.sub_nav" :key="i" @click.stop="to_service(subitem.id)">{{subitem.title}}</i>
                    </div>
                    <div class="drawer_sub_nav" v-else-if="item.value === 4">
                        <i v-for="(subitem,i) in item.sub_nav" :key="i" @click.stop="to_news(subitem.id)">{{subitem.name}}</i>
                    </div>
                </div>
                <div class="drawer_tab_index" :class="{active:Englist}" @click="to_tab()">
                    <b>中</b><i>/</i>English
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'myHeader',
    data () {
        return {
            drawer:false,
            Englist:false,
            siteInfo:{},
            nav_list:[
                {name: '主页',path: '/',value:0},
                {
                    name: '关于万事航',
                    path: '/about',
                    value:1,
                    sub_nav:[
                        {name: '公司简介',path: '/about',value:0},
                        {name: '发展历程',path: '/about_progress',value:1},
                        {name: '团队照片',path: '/about_team',value:2},
                        {name: '运输案例',path: '/about_case',value:3},
                        {name: '视频展示',path: '/about_view',value:4},
                        {name: '人才招募',path: '/about_job',value:5},
                    ],
                },
                {
                    name: '业务范围',
                    path: '/service',
                    value:2,
                    sub_nav:[],
                },
                {name: '产品方案',path: '/product_case',value:3},
                {
                    name: '新闻中心',
                    path: '/news?id=0',
                    value:4,
                    sub_nav:[],
                },
                {name: '联系我们',path: '/contact',value:5},
            ],
            news_nav:[
                {name: '行业动态',id:0},
                {name: '集团新闻',id:1},
                {name: '物流政策',id:2}
            ],
            mobile_w:0
        }
    },
    created () {
        this.pageSiteMsg();
        this.pageData();
        this.mobile_w = window.innerWidth;
    },
    methods:{
        pageSiteMsg(){
            let siteMsg = JSON.parse(localStorage.getItem('site_msg'));
            if(siteMsg){
                this.siteInfo = siteMsg;
            }else{
                this.$api.siteMsg().then(res => {
                    this.siteInfo = res.data.siteMsg;
                    let site_msg = JSON.stringify(res.data.siteMsg);
                    localStorage.setItem('site_msg',site_msg);
                });
            }
        },
        pageData(){
            this.$api.businessList().then(res => {
                this.nav_list[2].sub_nav = res.data;
            });
            this.nav_list[4].sub_nav = this.news_nav;
        },
        nav_link(path){
            this.$router.push({
                path:path
            }, () => {});
        },
        subnav_link(path){
            this.$router.push({
                path:path
            }, () => {});
        },
        to_service(id){
            let path = `/service?id=${id}`
            console.log(path);
            this.$router.replace(path)
            this.$router.go(0)
        },
        to_news(id){
            let path = `/news?id=${id}`
            console.log(path);
            this.$router.replace(path)
            this.$router.go(0)
        },
        to_index(){
            this.$router.push({
                path:'/'
            });
        },
        to_tab() {
            let links = 'https://www.mascot-cn.com/en';
            window.open(links, '_self')
        }
    },
}
</script>


<style scoped>
.nav{width:100%;height:90px;position:fixed;left:0;top:0;z-index:999;background:#fff;}
.nav_height{width:100%;height:90px;display:block;float:left;}
.nav_height.hide{display:none;}
.nav .nav_contain{width:1200px;height:90px;margin:0 auto;}
.nav_contain .logo{width:30%;height:90px;display:inline-block;float:left;cursor:pointer;padding:5px 0;}
.nav_contain .logo img{height:80px;width:auto;display:block;float:left;}
.nav_contain .nav_nr{width:70%;height:90px;display:inline-block;float:left;text-align:right;}
.nav_contain .nav_nr .nav_li{width:auto;height:90px;display:inline-block;cursor:pointer;position:relative;}
.nav_contain .nav_nr .nav_li span{font-size:18px;display:block;
    line-height:90px;color:#000;height:90px;padding:0 25px;}
.nav_contain .nav_nr .nav_li.active span{color:#fff;background:#0a64ba;}
.nav_contain .nav_nr .nav_li:hover span{color:#0a64ba;}
.nav_contain .nav_nr .nav_li.active:hover span{color:#fff;}
.tab_index{width:90px;height:32px;display:inline-block;border:1px solid #7d7d7d;margin:29px 0 29px 25px;font-weight:normal;
    vertical-align:top;border-radius:4px;font-size:13px;color:#666;line-height:30px;text-align:center;cursor:pointer;transition:0.8s;}
.tab_index b{font-weight:bold;color:#0a64ba;}
.tab_index i{margin:0 2px;font-style:normal;}
.tab_index:hover{border-color:#0a64ba;transition:0.8s;color:#0a64ba;}
.tab_index.active{font-weight:bold;color:#0a64ba;}
.tab_index.active b{font-weight:normal;color:#666;}
.nav_contain .nav_nr .nav_li:hover .sub_nav{display:block;}
.sub_nav{width:100%;height:auto;background:#000;position:absolute;left:0;top:90px;z-index:100;float:left;display:none;}
.sub_nav i{width:100%;min-height:41px;border-bottom:1px solid;border-color: rgba(255,255,255,0.2);float:left;justify-content:center;align-items:center;
    padding:5px 15px;font-size:12px;color: rgba(255,255,255);text-align:center;display:inline-flex;font-style:normal;}
.sub_nav i:last-child{border-color:transparent;}
.sub_nav i:hover{color:rgba(255,255,255,0.5);}
.drawer{display:none}
.el-icon-s-fold{display:none;}
@media (min-width:992px) and (max-width:1200px){
    .nav{height:80px;}
    .nav_height{height:80px;}
    .nav .nav_contain{width:1000px;height:80px;}
    .nav_contain .logo{width:30%;height:80px;padding:5px 0;}
    .nav_contain .logo img{height:70px;}
    .nav_contain .nav_nr{width:70%;height:80px;}
    .nav_contain .nav_nr .nav_li{height:80px;}
    .nav_contain .nav_nr .nav_li span{font-size:16px;line-height:80px;height:80px;padding:0 15px;}
    .tab_index{width:80px;height:32px;display:inline-block;border:1px solid #7d7d7d;margin:24px 0 24px 25px;font-weight:normal;
        vertical-align:top;border-radius:4px;font-size:12px;color:#666;line-height:30px;text-align:center;cursor:pointer;transition:0.8s;}
    .sub_nav{top:80px;}
    .sub_nav i{min-height:35px;padding:2px 10px;font-size:12px;}
}
@media (min-width:768px) and (max-width:991px){
    .nav{height:70px;}
    .nav_height{height:70px;}
    .nav .nav_contain{width:750px;height:70px;}
    .nav_contain .logo{width:20%;height:70px;padding:10px 0;}
    .nav_contain .logo img{height:50px;}
    .nav_contain .nav_nr{width:80%;height:70px;}
    .nav_contain .nav_nr .nav_li{height:70px;}
    .nav_contain .nav_nr .nav_li span{font-size:14px;line-height:70px;height:70px;padding:0 10px;}
    .tab_index{width:70px;height:32px;display:inline-block;border:1px solid #7d7d7d;margin:19px 0 19px 20px;font-weight:normal;
        vertical-align:top;border-radius:4px;font-size:12px;color:#666;line-height:30px;text-align:center;cursor:pointer;transition:0.8s;}
    .sub_nav{top:70px;}
    .sub_nav i{min-height:35px;padding:2px 10px;font-size:12px;}
}
@media (max-width:767px){
    .nav{height:45px;background:#0a64ba;}
    .nav_height{height:45px;}
    .nav .nav_contain{width:100%;height:44px;}
    .nav_contain .logo{width:50%;height:44px;padding:5px 0 5px 10px;}
    .nav_contain .logo img{height:34px;}
    .nav_contain .nav_nr{width:50%;height:44px;display:none;}
    .nav_contain i.el-icon-s-fold{font-size:24px;color:#fff;line-height:44px;position:absolute;right:15px;top:0;z-index:2;display:block;}
    .drawer{display:block}
    .drawer_nav{width:100%;height:100%;display:block;float:left;}
    .drawer_nav .logo{width:100%;height:auto;float:left;padding:5px 15px 15px;}
    .drawer_nav .logo img{width:100%;height:auto;}
    .drawer_nav .drawer_nav_li{width:100%;min-height:40px;height:auto;text-align:center;float:left;display:block;}
    .drawer_nav .drawer_nav_li.active span{color:#fff;background:#0c57c3;}
    .drawer_nav .drawer_nav_li span{width:100%;height:44px;font-size:15px;color:#333;line-height:44px;text-align:center;float:left;display:block;}
    .drawer_nav .drawer_nav_li.active .drawer_sub_nav{display:block;}
    .drawer_sub_nav{width:100%;height:auto;min-height:30px;float:left;display:none;}
    .drawer_sub_nav i{font-size:12px;min-height:30px;line-height:20px;text-align:center;float:left;font-style:normal;width:100%;display:block;padding:5px 0;}
    .drawer_sub_nav i.on{background:#0a64ba;color:#fff;}
    .drawer_tab_index{width:90px;height:32px;display:inline-block;border:1px solid #7d7d7d;font-weight:normal;float:left;
        left:50%;margin-left:-45px;margin-top:20px;position:relative;
        vertical-align:top;border-radius:4px;font-size:13px;color:#666;line-height:30px;text-align:center;cursor:pointer;transition:0.8s;}
    .drawer_tab_index b{font-weight:bold;color:#0a64ba;}
    .drawer_tab_index i{margin:0 2px;font-style:normal;}
    .drawer_tab_index:hover{border-color:#0a64ba;transition:0.8s;color:#0a64ba;}
    .drawer_tab_index.active{font-weight:bold;color:#0a64ba;}
    .drawer_tab_index.active b{font-weight:normal;color:#666;}
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue